import { useState, useEffect } from 'react';
import SchemaOrg from '../../components/base/SchemaOrg';

export default function TestimonialsPage() {
  const [activeFilter, setActiveFilter] = useState('all');

  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  useEffect(() => {
    const pageTitle = '客戶評價｜水塔清洗水管疏通5星好評｜永業環保';
    const pageDesc = '永業環保客戶真實評價，水塔清洗、水管疏通、水溝清理服務5星好評。超過500位滿意客戶見證，20年專業清潔服務，您的信賴首選。';
    const pageKeywords = '客戶評價,水塔清洗評價,水管疏通評價,清潔服務推薦,永業環保評分';
    const pageUrl = `${siteUrl}/testimonials`;

    document.title = pageTitle;

    const setMeta = (selector: string, attr: string, value: string) => {
      const el = document.querySelector(selector);
      if (el) el.setAttribute(attr, value);
    };

    setMeta('meta[name="description"]', 'content', pageDesc);
    setMeta('meta[name="keywords"]', 'content', pageKeywords);
    setMeta('link[rel="canonical"]', 'href', pageUrl);
    setMeta('meta[property="og:title"]', 'content', pageTitle);
    setMeta('meta[property="og:description"]', 'content', pageDesc);
    setMeta('meta[property="og:url"]', 'content', pageUrl);
    setMeta('meta[name="twitter:title"]', 'content', pageTitle);
    setMeta('meta[name="twitter:description"]', 'content', pageDesc);
  }, [siteUrl]);

  const testimonials = [
    {
      name: '陳先生',
      location: '桃園市桃園區',
      service: '水塔清洗',
      rating: 5,
      date: '2024年3月',
      comment: '服務非常專業，師傅很細心地清洗水塔，還用內視鏡讓我看清洗前後的差異。清洗後水質明顯改善，價格也很合理。強烈推薦！',
      avatar: 'https://public.readdy.ai/ai/img_res/c7a9107b443a8b4f21e61b11cdddd9aa.jpg'
    },
    {
      name: '林小姐',
      location: '新北市板橋區',
      service: '水管疏通',
      rating: 5,
      date: '2024年2月',
      comment: '廚房水管堵塞很久了，試過很多方法都沒用。永業環保的師傅用高壓水刀很快就疏通了，而且還教我日常保養的方法。服務態度很好！',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20female%20customer%20portrait%20smiling%20friendly%20expression%20clean%20background%20high%20quality%20photography&width=200&height=200&seq=testimonial-avatar-2&orientation=squarish'
    },
    {
      name: '王經理',
      location: '台北市信義區',
      service: '水溝清理',
      rating: 5,
      date: '2024年1月',
      comment: '我們大樓的排水溝長期淤積，每次下雨都會積水。永業環保團隊很專業，徹底清理了所有淤泥，現在排水非常順暢。值得信賴的公司！',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20manager%20portrait%20confident%20expression%20business%20attire%20clean%20background%20high%20quality%20photography&width=200&height=200&seq=testimonial-avatar-3&orientation=squarish'
    },
    {
      name: '張太太',
      location: '桃園市中壢區',
      service: '內視鏡檢查',
      rating: 5,
      date: '2023年12月',
      comment: '家裡排水一直有問題但找不到原因，永業環保用內視鏡檢查後發現是管線破裂。師傅很專業地解釋問題並提供解決方案，讓我很放心。',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20female%20homeowner%20portrait%20warm%20smile%20friendly%20expression%20clean%20background%20high%20quality%20photography&width=200&height=200&seq=testimonial-avatar-4&orientation=squarish'
    },
    {
      name: '李先生',
      location: '新竹市東區',
      service: '水塔清洗',
      rating: 5,
      date: '2023年11月',
      comment: '定期找永業環保清洗水塔已經三年了，每次服務都很滿意。師傅準時到達，工作認真仔細，清洗後還會提供詳細報告。是值得長期合作的好廠商！',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20customer%20portrait%20satisfied%20expression%20clean%20background%20high%20quality%20photography&width=200&height=200&seq=testimonial-avatar-5&orientation=squarish'
    },
    {
      name: '黃小姐',
      location: '台北市大安區',
      service: '水管疏通',
      rating: 5,
      date: '2023年10月',
      comment: '半夜馬桶堵塞，打電話給永業環保，師傅很快就到了。專業的設備和技術，不到一小時就解決問題。24小時服務真的很貼心！',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20female%20customer%20portrait%20happy%20expression%20clean%20background%20high%20quality%20photography&width=200&height=200&seq=testimonial-avatar-6&orientation=squarish'
    },
    {
      name: '劉經理',
      location: '桃園市平鎮區',
      service: '水溝清理',
      rating: 5,
      date: '2023年9月',
      comment: '我們工廠的排水系統很複雜，永業環保團隊很有經驗，快速找出問題點並徹底清理。施工過程不影響工廠運作，非常專業！',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20factory%20manager%20portrait%20serious%20expression%20industrial%20background%20high%20quality%20photography&width=200&height=200&seq=testimonial-avatar-7&orientation=squarish'
    },
    {
      name: '吳太太',
      location: '新北市新莊區',
      service: '水塔清洗',
      rating: 5,
      date: '2023年8月',
      comment: '第一次清洗水塔，本來很擔心。但永業環保的師傅很專業，詳細說明清洗流程，還讓我看清洗前後的照片。水質改善很多，全家人都很滿意！',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20female%20homeowner%20portrait%20relieved%20smile%20clean%20background%20high%20quality%20photography&width=200&height=200&seq=testimonial-avatar-8&orientation=squarish'
    },
    {
      name: '周先生',
      location: '桃園市八德區',
      service: '內視鏡檢查',
      rating: 5,
      date: '2023年7月',
      comment: '排水管老是有異味，用內視鏡檢查後發現管線內有破損。師傅很仔細地檢查每一段管線，找出所有問題點。專業的服務讓人很放心！',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20customer%20portrait%20satisfied%20expression%20clean%20background%20high%20quality%20photography&width=200&height=200&seq=testimonial-avatar-9&orientation=squarish'
    },
    {
      name: '鄭小姐',
      location: '台北市內湖區',
      service: '水管疏通',
      rating: 5,
      date: '2023年6月',
      comment: '浴室排水很慢，試過通樂都沒效。永業環保師傅用高壓水刀疏通，效果立竿見影！而且價格透明，沒有額外收費。下次還會找他們！',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20female%20customer%20portrait%20cheerful%20smile%20clean%20background%20high%20quality%20photography&width=200&height=200&seq=testimonial-avatar-10&orientation=squarish'
    },
    {
      name: '許經理',
      location: '新竹市北區',
      service: '水溝清理',
      rating: 5,
      date: '2023年5月',
      comment: '我們餐廳的排水溝經常堵塞，影響營業。永業環保提供定期維護服務，現在完全沒有堵塞問題了。專業、準時、價格合理！',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20restaurant%20manager%20portrait%20confident%20smile%20clean%20background%20high%20quality%20photography&width=200&height=200&seq=testimonial-avatar-11&orientation=squarish'
    },
    {
      name: '楊太太',
      location: '桃園市龜山區',
      service: '水塔清洗',
      rating: 5,
      date: '2023年4月',
      comment: '社區水塔清洗找永業環保，住戶都很滿意。師傅們工作很認真，清洗得很乾淨，還提供完整的清洗報告。是值得推薦的優質廠商！',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20female%20community%20manager%20portrait%20warm%20smile%20clean%20background%20high%20quality%20photography&width=200&height=200&seq=testimonial-avatar-12&orientation=squarish'
    }
  ];

  const schemas = [
    {
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      '@id': `${siteUrl}/#organization`,
      name: '永業環保',
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '5.0',
        reviewCount: testimonials.length.toString(),
        bestRating: '5',
        worstRating: '1'
      }
    },
    {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      '@id': `${siteUrl}/testimonials#page`,
      url: `${siteUrl}/testimonials`,
      name: '客戶評價 - 永業環保',
      description: '永業環保真實客戶評價，水塔清洗、水管疏通、水溝清理、內視鏡檢查服務5星評分',
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首頁', item: siteUrl },
          { '@type': 'ListItem', position: 2, name: '客戶評價', item: `${siteUrl}/testimonials` }
        ]
      }
    },
    ...testimonials.map((testimonial, index) => ({
      '@context': 'https://schema.org',
      '@type': 'Review',
      '@id': `${siteUrl}/testimonials#review-${index + 1}`,
      itemReviewed: {
        '@id': `${siteUrl}/#organization`
      },
      author: {
        '@type': 'Person',
        name: testimonial.name
      },
      reviewRating: {
        '@type': 'Rating',
        ratingValue: testimonial.rating.toString(),
        bestRating: '5',
        worstRating: '1'
      },
      reviewBody: testimonial.comment,
      datePublished: testimonial.date
    }))
  ];

  return (
    <>
      <SchemaOrg schema={schemas} />
      <div className="pt-24">
        {/* Hero Section */}
        <section className="relative bg-gradient-to-br from-amber-500 via-orange-500 to-red-500 text-white py-20">
          <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-5xl font-bold mb-6">客戶評價</h1>
            <p className="text-xl text-orange-50 max-w-3xl mx-auto leading-relaxed">
              真實客戶見證，用心服務每一位客戶，打造值得信賴的專業品牌
            </p>
          </div>
        </section>

        {/* Statistics Section */}
        <section className="py-16 bg-gradient-to-br from-gray-50 to-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
              {/* Overall Rating */}
              <div className="lg:col-span-1 bg-white rounded-2xl shadow-lg p-8 text-center border border-gray-100">
                <div className="text-6xl font-bold text-amber-500 mb-3">5.0</div>
                <div className="flex justify-center mb-3">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i
                      key={star}
                      className={`${
                        star <= 5 ? 'ri-star-fill text-yellow-400' : 'ri-star-line text-gray-300'
                      } text-lg`}
                    ></i>
                  ))}
                </div>
                <div className="text-gray-600 font-medium">整體評分</div>
                <div className="text-sm text-gray-500 mt-2">共 {testimonials.length} 則評價</div>
              </div>

              {/* Service Ratings */}
              {['水塔清洗', '水管疏通', '水溝清理', '內視鏡檢查'].map((service) => {
                const serviceReviews = testimonials.filter((t) => t.service === service);
                const avgRating = serviceReviews.length > 0
                  ? (serviceReviews.reduce((sum, t) => sum + t.rating, 0) / serviceReviews.length).toFixed(1)
                  : '0.0';
                return (
                  <div
                    key={service}
                    className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100 hover:shadow-xl transition-all"
                  >
                    <div className="text-center mb-4">
                      <div className="text-3xl font-bold text-amber-500 mb-2">{avgRating}</div>
                      <div className="flex justify-center mb-2">
                        {[1, 2, 3, 4, 5].map((star) => (
                          <i
                            key={star}
                            className={`${
                              star <= Math.round(parseFloat(avgRating)) ? 'ri-star-fill text-yellow-400' : 'ri-star-line text-gray-300'
                            } text-lg`}
                          ></i>
                        ))}
                      </div>
                    </div>
                    <div className="text-center">
                      <div className="font-bold text-gray-900 mb-1">{service}</div>
                      <div className="text-sm text-gray-500">{serviceReviews.length} 則評價</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* Filter Section */}
        <section className="bg-white py-8 sticky top-0 z-10 shadow-sm border-b border-gray-100">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-wrap justify-center gap-3">
              {['全部服務', '水塔清洗', '水管疏通', '水溝清理', '內視鏡檢查'].map((service) => (
                <button
                  key={service}
                  onClick={() => setActiveFilter(service === '全部服務' ? 'all' : service)}
                  className={`px-6 py-2.5 rounded-full font-medium transition-all whitespace-nowrap cursor-pointer ${
                    activeFilter === service
                      ? 'bg-amber-500 text-white shadow-lg shadow-amber-500/30'
                      : 'bg-gray-100 text-gray-700 hover:bg-amber-50 hover:text-amber-600 border border-gray-200'
                  }`}
                >
                  {service}
                </button>
              ))}
            </div>
            <div className="text-center mt-4 text-gray-600">
              顯示 <strong className="text-amber-500">{testimonials.length}</strong> 則評價
            </div>
          </div>
        </section>

        {/* Testimonials Grid */}
        <section className="py-16 bg-gradient-to-br from-gray-50 to-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {testimonials.map((testimonial) => (
                <div
                  key={testimonial.name}
                  className="bg-white rounded-2xl shadow-lg p-8 hover:shadow-2xl transition-all duration-300 border border-gray-100"
                >
                  {/* Header */}
                  <div className="flex items-start gap-4 mb-6">
                    <div className="w-16 h-16 flex items-center justify-center">
                      <img
                        src={testimonial.avatar}
                        alt={`${testimonial.name}的頭像`}
                        title={testimonial.name}
                        className="w-full h-full rounded-full object-cover object-top border-2 border-amber-500"
                      />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg font-bold text-gray-900 mb-1">
                        {testimonial.name}
                      </h3>
                      <div className="flex items-center gap-2 text-sm text-gray-600 mb-2">
                        <i className="ri-map-pin-line text-amber-500"></i>
                        <span>{testimonial.location}</span>
                      </div>
                      <div className="flex items-center gap-2">
                        {[1, 2, 3, 4, 5].map((star) => (
                          <i
                            key={star}
                            className={`${
                              star <= testimonial.rating ? 'ri-star-fill text-yellow-400' : 'ri-star-line text-gray-300'
                            } text-lg`}
                          ></i>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Service Tag */}
                  <div className="mb-4">
                    <span className="inline-block px-4 py-1.5 bg-amber-50 text-amber-600 text-sm font-medium rounded-full border border-amber-200">
                      {testimonial.service}
                    </span>
                  </div>

                  {/* Content */}
                  <p className="text-gray-700 leading-relaxed mb-4">
                    {testimonial.comment}
                  </p>

                  {/* Date */}
                  <div className="flex items-center gap-2 text-sm text-gray-500">
                    <i className="ri-calendar-line"></i>
                    <span>{testimonial.date}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-br from-amber-500 via-orange-500 to-red-500 text-white relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-black/10"></div>
          <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <div className="mb-8">
              <div className="inline-flex items-center gap-2 px-6 py-3 bg-white/20 backdrop-blur-sm rounded-full text-lg font-bold mb-6">
                <i className="ri-star-fill text-yellow-300 text-2xl"></i>
                <span>客戶滿意度 5.0 分</span>
              </div>
            </div>
            <h2 className="text-4xl font-bold mb-6">體驗我們的專業服務</h2>
            <p className="text-xl text-orange-50 mb-10 leading-relaxed">
              加入數百位滿意客戶的行列，讓我們為您提供最優質的服務
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a
                href="/contact"
                className="inline-flex items-center gap-2 px-8 py-4 bg-white text-orange-600 rounded-full font-bold text-lg hover:bg-orange-50 transition-all shadow-xl hover:shadow-2xl hover:scale-105 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line text-xl"></i>
                立即預約服務
              </a>
              <a
                href="/cases"
                className="inline-flex items-center gap-2 px-8 py-4 bg-orange-500/20 backdrop-blur-sm text-white rounded-full font-bold text-lg hover:bg-orange-500/30 transition-all border-2 border-white/30 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-image-line text-xl"></i>
                查看施工案例
              </a>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
